export const environment = {
  /** GENERAL */
  ROLLBAR_ENV: 'sandbox',
  production: true,
  appBaseUrl: 'https://sandbox2-app.explain.fr',
  captchaPublicKey: '0x4AAAAAACoXHR5Mx3RTOh6P',

  /** ENDPOINTS */
  explainApiUrl: 'https://beta.api.sandbox2-goodwill.explain.fr/api/v1/',
  explainDceExportWorkerUrl: 'https://export.app-sandbox.explain.fr/download',
  explainApiGatewayUrl: 'https://3ux6eqqi53.execute-api.eu-west-3.amazonaws.com/api-explain/', // api-sb2-explain-gateway
  smartSearchApiGatewayUrl: 'wss://f5vis3647f.execute-api.eu-west-3.amazonaws.com/sandbox2/',
  s3SmartSearchBaseUrl: `https://s3-sb2-smart-search-results.s3.amazonaws.com`,
  responseProjectApiGateway: 'wss://api.sb2-response-project-processor.explain.fr/v1/websocket/response-project',

  /** BUCKETS */
  s3DigestResultsBaseUrl: `https://s3-sb-digest-results-2.s3.eu-west-3.amazonaws.com`,

  /** NPS */
  npsFormShouldBeDisplayed: true,
  npsFormUrl: 'https://satisfaction.staging-goodwill.explain.fr/',
  retrieveResponseUrl: 'https://scagn3utp8.execute-api.eu-west-3.amazonaws.com/staging',
  npsMinAge: 30,
  npsMinDate: '2022-06-20',
  npsMaxDate: '2022-07-22',
};
